module.exports = __webpack_public_path__ + "static/media/plane-arrival.76342b3e.svg";